import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { getMarketResearchData } from "../../services/api.service";
import LoaderTop from "../common/loaderTop";

const Sendinlue = () => {
  const styles = useStyles();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [interest, setInterest] = useState("");
  const [email, setEmail] = useState("");

  const submitAPI = async () => {
    setIsLoading(true);
    const payLoad = {
      api_name: "public_global_risk_mailing_list",
      data: {
        email: email,
        interest: interest,
      },
    };
    const data = await getMarketResearchData(payLoad);
    setIsLoading(false);
    if (data && data.meta && data.meta.status == 200) {
      localStorage.setItem("DOES_TIME_SPENT", false);
      setOpen(false);
      setIsSubmitted(true);
      setInterest("");
      setEmail("");
      setTimeout(() => {
        setIsSubmitted(false);
      }, 4000);
    }
  };

  useEffect(() => {
    let temp = localStorage.getItem("DOES_TIME_SPENT");
    if (temp && temp == "true") {
      setOpen(true);
    }
    if (temp != "false") {
      setTimeout(() => {
        localStorage.setItem("DOES_TIME_SPENT", true);
        setOpen(true);
      }, 120000);
    }
    
  }, []);

  return (
    <div>
      {isLoading ? <LoaderTop /> : null }
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={open}
        className={styles.modalContainer}
      >
        <DialogTitle className={styles.modalTitle}>
          <span className={styles.modalTitle}>
            Want More Kavida data? Join our <br /> email list to continue.
          </span>
        </DialogTitle>
        <DialogContent>
          {!isSubmitted ? (
            <>
              <span className={styles.description}>
                Joining Kavida mailing list gets you first access to new data
                and insights.
              </span>
              <span className={styles.label}>
                {" "}
                I am interested in intelligence on...
              </span>
              <select
                onChange={(e) => {
                  setInterest(e.target.value);
                }}
                className={styles.dropdown}
              >
                <option value="" disabled></option>
                <option value="Supply chain disruptions">
                  Supply chain disruptions
                </option>
                <option>Logistics</option>
                <option>Commodities</option>
                <option>Environmental Social Governance</option>
                <option>Competitor intelligence</option>
              </select>
              <span className={styles.label}>Work Email</span>
              <input
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                className={styles.workEmail}
                type="email"
              />
              <div className={styles.buttonContainer}>
                <button onClick={submitAPI} className={styles.joinNow}>
                  Join Now
                </button>
              </div>
            </>
          ) : (
            <h3 className={styles.successMessage}>
              Your response has been submitted
            </h3>
          )}
        </DialogContent>
        {/* <DialogActions className={styles.modalAction}> */}
        {/* <Button autoFocus onClick={handleSearch} color="primary">
                  Search
                </Button> */}
        {/* </DialogActions> */}
      </Dialog>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  modalContainer: {
    "& .MuiDialog-paper": {
      padding: "20px !important",
      borderRadius: "20px !important",
      backgroundColor: "#d9d9d9 !important",
      color: "black !important",
    },
  },
  buttonContainer: {
    textAlign: "center",
  },
  dropdown: {
    float: "left",
    width: "100%",
    padding: "10px",
    border: "none",
  },
  workEmail: {
    padding: "10px",
    float: "left",
    border: "none",
    width: "100%",
    marginBottom: "30px",
  },
  joinNow: {
    backgroundColor: "#6bac68",
    color: "#FFF",
    fontSize: "22px",
    padding: "13px",
    minWidth: "255px",
    border: "none",
    marginBottom: "28px",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.7
    }
  },
  label: {
    fontSize: "12px",
    width: "100%",
    float: "left",
    fontSize: "19px",
    fontWeight: "bold",
    margin: "12px 0",
  },
  modalTitle: {
    textAlign: "center",
    fontSize: "30px",
  },
  description: {
    fontSize: "22px",
  },
  successMessage: {
    textAlign: "center",
    color: "green",
    fontSize: "24px"
  },
}));

export default Sendinlue;
